import './modules/modals';
import './modules/forms';
import './modules/masks';
import './modules/spinner';
import './modules/scroll';
import './modules/menus';
import './modules/tabs';
import './modules/galleries';
import './modules/rotators';
import './modules/faq';
import './modules/loading';
import './modules/winners';
import './modules/registration';
import './modules/animations/partners';
import './modules/animations/inview';

import { initNewsSlider } from './modules/rotators';
import TimerWidget from './modules/widgets/timer';
import ClosableTeaser from './modules/widgets/closable-teaser';
// import InstagramWidget from './modules/widgets/instagram';
import './modules/targets';

import store from './contest/store';
import WorksList from './contest/components/works-list';
import StagesList from './contest/components/stages-list';
import RatingTable from './contest/components/rating-table';
import ParticipantComponent from './contest/components/participant';

import YoutubeVideo from './contest/components/youtube-video';

// import SharePopup from './contest/components/share';
// import Captcha from "./contest/components/captcha";
import Vote from './contest/components/vote';

const timer = new TimerWidget();

// Init instagram widget
// ---------------------

// const instagram = new InstagramWidget({
//   limit: {
//     default: 12,
//     mobile: 4,
//   },
// });


// Panel hiding
// ------------

// const panel = new ClosableTeaser({
//   selector: '.js-bottom-panel',
//   closeSelector: '.js-close-bottom-panel',
//   storageKey: 'PANEL_HIDE_DATE',
//   daysToHide: 5,
//   showCallback: initNewsSlider,
// });


// Register global Vue components
// ------------------------------
// Vue.component('contest-captcha', Captcha);
Vue.component('contest-vote', Vote);

// Vue app entrypoint
// ------------------
window.vm = new Vue({
  el: '#structure',
   store,
  components: {
     'works-list': WorksList,
     'stages-list': StagesList,
     'participant-component': ParticipantComponent,
     'rating-table': RatingTable,
    // 'share-popup': SharePopup,
    'youtube-video': YoutubeVideo,
  },
  data: {
    participantToShare: null,
    captchaPromise: null,
    promiseResolve: null,
    activeSharingStage: null,
  },
  created() {
     this.$store.dispatch('initParticipantsListData');
     this.$store.dispatch('initStagesListData');
  },
  methods: {
    // callShareModal(participantId) {
    //   const vm = this;
    //   vm.participantToShare = participantId;
    //   $.overlayLoader(true, {
    //     node: $('#share-popup'),
    //     hideSelector: '.js-close-popup',
    //     fixedElements: '.js-fixed-element',
    //     onHide() {
    //       vm.activeSharingStage = null;
    //     },
    //   });
    // },
  },
});


if ($('.stage-4').length) {
  $(window).on('scroll', function(){
    floatedCardPositionCalculate();
  });
  $(window).on('resize', function(){
    floatedCardPositionCalculate();
  });

  function floatedCardPositionCalculate(){
    let width = $(window).width();
    if (width >= 1250){
      let screen_h = $(window).height();
      let scroll = $(document).scrollTop();
      let margin_top = scroll + 35;
      let k = 0.3;

      if (width > 1400) { k = 0.35; }
      if (width > 1550) { k = 0.5; }
      if (width > 1800) { k = 0.66; }

      if (scroll > (screen_h * k)) margin_top = (screen_h * k) + 35;
      $('.js-floated-card').css('margin-top', margin_top);

    } else {

      $('.js-floated-card').css('margin-top', 35);
    }
  }
}